import React, { Component } from 'react'
import Seo from "./Seo"
import Footer from './Footer'
import {Helmet} from 'react-helmet'
import './SubPages.scss'


class AboutUs extends Component {
  render() {
    return (
      <div>
        <Helmet>
          {/* <title>about us</title> */}
          <meta name="Aditya Birla Sun Life AMC Limited Axis Asset Management Company Ltd Baroda Asset Management India Limited  BNP Paribas Asset Management India Pvt Ltd
            BOI AXA Investment Managers Private Limited  Canara Robeco Asset Management Company Limited  DSP Investment Managers Private Limited
            Edelweiss Asset Management Limited Franklin Templeton Asset Management (India) Private Limited  HDFC Asset Management Company Limited
            HSBC Global Asset Management (India) Private Limited ICICI Prudential Asset Management Company Limited IDBI Asset Management Ltd
            IDFC Asset Management Company Limited IIFL Asset Management Co Ltd Indiabulls Asset Management Company Limited Invesco Asset Management Company Pvt Ltd
            ITI Asset Management Limited JM Financial Asset Management Private Limited  Kotak Mahindra Asset Management Company Limited L&T Investment Management Limited
            LIC Mutual Fund Asset Management Limited  Mahindra Manulife Investment Management Private Limited  Mirae Asset Investment Managers (India) Private Limited
            Motilal Oswal Asset Management Company Limited Navi AMC Limited Nippon Life India Asset Management Limited NJ Asset Management Private Limited
            PGIM India Asset Management Private Limited PPFAS Asset Management Pvt Ltd Quant Money Managers Limited Quantum Asset Management Company Private Limited
            Samco Asset Management Private Limited SBI Funds Management Limited Shriram Asset Management Company Limited Sundaram Asset Management Company Limited
            Tata Asset Management Private Limited Taurus Asset Management Company Limited Trust Asset Management Private Limited Union Asset Management Company Pvt Ltd
            UTI Asset Management Company Private Limited WhiteOak Capital Asset Management Limited" content='about our page' />
      
        </Helmet>
        <div className="text-center  about_container">
          <img src='../../images/background_image.jpg' alt='SBI Funds Management Limited'></img>
          {/* <video src="../../videos/video.mp4" autoPlay loop muted /> */}
          <div className="text_about">
            <h1>About Us</h1>
            <p>''All the forces in the world are not so powerful as an idea whose time has come''
              - Victor Hugo More than it inspired us, it upheld our conviction to take the plunge.
              So took the birth of Pulse Labs!<br></br></p>
          </div>
        </div>
        <div className='container-fluid'>
          <div className="row  justify-content-around margin_overlay">

            <div className="col-md-3 card_About">
              <h3 className="py-3">Our Pulse…</h3>
              <p>
                Life for us at Pulse Labs is about thriving on ideas and insights that are ground-breaking.
                Contradictory it may sound, but our people with diverse mind-sets makes this task more easily.
                What we have in common is the vision and passion for excellence. Outcome is in the form of solutions
                that are futuristic. For us, Innovation means Life. Welcome to Pulse Labs!
              </p>
            </div>
            <div className="col-md-3 card_About">
              <h3 className="py-3">The Market Pulse…</h3>
              <p>
                Financial Advisory Profession in India is moving to its next level.
                The transition is as much challenging as exciting. Dwindling commissions has forced Financial
                Advisors to look at alternate revenue models. Regulatory Oscillations, Irrational Client Behaviour,
                Volatile Markets are adding to their woes.
              </p>
            </div>
            <div className="col-md-3 card_About">
              <h3 className="py-3">The Business Pulse…</h3>
              <p>
                Pulse Labs as a Business House cater to the B2B segment in the Financial Services space.
                We focus on creating solutions cemented with Technology, Research & Analytics, which are
                best suited for the GenNext Advisory Firm. We offer this as APIs to FinTechs and Apps to IFAs (RIAs & MFDs)
              </p>
            </div>
          </div>
        </div>
        {/* <div className='img_test'>
              <img className='test_img'src='../../images/test_2.jpg' alt='test'></img>
              <div className='overlay container'>
              <div className='text_left col-md-6'>
          <h1 className='py-5'>About Us</h1>
          <p>``All the forces in the world are not so powerful as an idea whose time has come''
            - Victor Hugo More than it inspired us, it upheld our conviction to take the plunge.
            So took the birth of Pulse Labs!<br></br></p>
            </div>
              </div>
            </div>
        <div className="row my-5 justify-content-around">
              
              <div className="col-md-3 card_About m-1">
                <h3 className="py-3">Our Pulse…</h3>
                <p>
                Life for us at Pulse Labs is about thriving on ideas and insights that are ground-breaking.
               Contradictory it may sound, but our people with diverse mind-sets makes this task more easily. 
               What we have in common is the vision and passion for excellence. Outcome is in the form of solutions
                that are futuristic. For us, Innovation means Life. Welcome to Pulse Labs!
                </p>
              </div>
              <div className="col-md-3 card_About m-1">
                <h3 className="py-3">The Market Pulse…</h3>
                <p>
                Financial Advisory Profession in India is moving to its next level.
            The transition is as much challenging as exciting. Dwindling commissions has forced Financial
            Advisors to look at alternate revenue models. Regulatory Oscillations, Irrational Client Behaviour,
            Volatile Markets are adding to their woes.
                </p>
              </div>
              <div className="col-md-3 card_About m-1">
                <h3 className="py-3">The Business Pulse…</h3>
                <p>
                Pulse Labs as a Business House cater to the B2B segment in the Financial Services space.
               We focus on creating solutions cemented with Technology, Research & Analytics, which are 
               best suited for the GenNext Advisory Firm. We offer this as APIs to FinTechs and Apps to IFAs (RIAs & MFDs)
                </p>
              </div>
            </div> */}

        <Footer />
        <Seo />
      </div>
    )
  }
}

export default AboutUs
